/**
 * DevConfigPage — /dev-config
 *
 * Cockpit completo v2: mapa, seleção de cidade/escola, atores, métricas.
 * Usa SimulationSetupPageV2 (snapshot do estado atual antes da restauração do /dev).
 *
 * O /dev usa a versão restaurada (SovereignSplash + dialog roxo elegante).
 * Este módulo preserva o v2 para uso futuro sem conflito.
 */

// O arquivo V2 foi copiado do original — a função ainda se chama SimulationSetupPage internamente.
// Importamos com alias para não conflitar com o SimulationSetupPage do /dev.
import { SimulationSetupPage as SimulationSetupPageV2 } from './SimulationSetupPageV2';

export function DevConfigPage() {
  return <SimulationSetupPageV2 />;
}



